module.exports = __webpack_public_path__ + "assets/img/browse.0b78adb2.png";